import { MUTATE_VALIDATING_ORDER, MUTATE_VALIDATING_ORDER_ERROR } from '../store/types'

// define a mixin object
export const orderValidation = {
  methods: {
    validateMaterial(material) {
      this.$store.commit(MUTATE_VALIDATING_ORDER, true)
      this.$store.commit(MUTATE_VALIDATING_ORDER_ERROR, false)
      // Check if the material has no validation errors
      let valid = true
      let messages = []

      // Validate material selection
      if (!material.code) {
        valid = false
        messages.push('- Er is nog geen materiaal gekozen')
      }

      // Validate sides
      if (material.filterFirst.indexOf('HPL') !== -1) {
        if (!material.side1) {
          valid = false
          messages.push('- Er is geen Zijde 1 gekozen')
        }
        if (!material.side2) {
          valid = false
          messages.push('- Er is geen Zijde 2 gekozen')
        }
      }

      // Validate panelrows
      let deliveryProgram = this.$store.getters.filterDeliveryProgram
      material.panels.forEach(function(panel) {
        if (deliveryProgram === 'Meubelpanelen') {
          if (panel.width == null) {
            messages.push('- Er is geen geldige "breedte" opgegeven (regel ' + panel.id + ')')
            valid = false
          }
          if (panel.amount == 0 || panel.amount == null) {
            messages.push('- Er is geen geldige "aantal" panelen opgegeven (regel ' + panel.id + ')')
            valid = false
          }
        } else {
          if (panel.amount == 0 || panel.amount == null) {
            messages.push('- Er is geen geldige "aantal" panelen opgegeven (regel ' + panel.id + ')')
            valid = false
          }
          if (!panel.valid || !panel.amount || panel.amount === 0) {
            messages.push('- Er is geen geldige paneel informatie opgegeven (regel ' + panel.id + ')')
            valid = false
          }
        }
      })

      // Check finish
      //console.log('debug validation materialFinish', this.$store.getters.materialFinish)
      if (this.$store.getters.materialFinish === null) {
        // Check if we have finish selected
        messages.push('- Er is geen kantafwerkig gekozen')
        valid = false
      } else if (this.$store.getters.materialFinish && parseInt(this.$store.getters.materialFinish.id) !== 0) {
        // Check if there is at least one checkbox enabled when we have a finish
        let checked = false
        material.panels.forEach(function (panel) {
          if (panel.l1 || panel.l2 || panel.b1 || panel.b2) {
            checked = true
          }
        })
        if (!checked) {
          messages.push('- Er is wel een kantafwerking gekozen (' + this.$store.getters.materialFinish.name + '), maar er zijn geen zijdes geselecteerd')
          valid = false
        }
      }

      if (!valid) {
        this.$store.commit(MUTATE_VALIDATING_ORDER, false)
        this.$store.commit(MUTATE_VALIDATING_ORDER_ERROR, 'Deze gekozen actie is niet mogelijk.<br/>Los a.u.b. als eerst de volgende errors op:<br/><br/>' + messages.join('<br/>'))
      }
      return valid
    },

    validateOrder(cart) {
      this.$store.commit(MUTATE_VALIDATING_ORDER, true)
      this.$store.commit(MUTATE_VALIDATING_ORDER_ERROR, false)

      // Check the current material (the other materials should be valid)
      let valid = this.validateMaterial(this.$store.getters.material)

      // eslint-disable-next-line
      if (!valid) {
        // In case the order does not validate properly
        // this.$store.commit(MUTATE_VALIDATING_ORDER, false)
        // this.$store.commit(MUTATE_VALIDATING_ORDER_ERROR, 'Dit is een error <br/> Fix a.u.b. als eerst de volgende errors')
        return false
      }

      // In case the order validates properly
      this.$store.commit(MUTATE_VALIDATING_ORDER, false)
      return true
    }
  }
}
